/* eslint-disable no-restricted-globals,no-prototype-builtins,camelcase,no-var,no-cond-assign,no-param-reassign,prefer-const,radix,@typescript-eslint/no-use-before-define */

import $ from 'jquery';
import Immutable from 'immutable';

export function ignoreExceptions(fn) {
  try {
    return fn();
  } catch (e) {
    /* noop */
    return undefined;
  }
}

export function parseQueryString() {
  let qs = location.search;

  if (typeof qs !== 'string') {
    return {};
  }

  qs = qs.trim().replace(/^(\?|#|&)/, '');

  if (!qs) {
    return {};
  }

  return qs.split('&').reduce((...args) => {
    const [ret, param] = args;
    const parts = param.replace(/\+/g, ' ').split('=');
    // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37
    let key = parts.shift();
    let val = parts.length > 0 ? parts.join('=') : undefined;

    key = decodeURIComponent(key);

    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    // noinspection JSCheckFunctionSignatures
    val = val === undefined ? null : decodeURIComponent(val);

    if (!ret.hasOwnProperty(key)) {
      Object.assign(ret, { [key]: val });
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      Object.assign(ret, { [key]: [ret[key], val] });
    }

    return ret;
  }, {});
}

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
export function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const isSafari = navigator.userAgent
  ? /safari/.test(navigator.userAgent.toLowerCase()) &&
    !/chrome/.test(navigator.userAgent.toLowerCase())
  : false;

export const isInternetExplorer =
  navigator.appVersion && navigator.userAgent
    ? navigator.appVersion.indexOf('MSIE') !== -1 ||
      navigator.userAgent.match(/(Trident|Edge)\//)
    : false;

// fetch details about WebGL
export const WebGLSupport = {
  isEnabled: false,
};

try {
  const canvas = document.createElement('canvas');
  const ctx =
    canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  const exts = ctx.getSupportedExtensions();

  exts.forEach((ext) => (WebGLSupport[ext] = true));

  WebGLSupport.isEnabled = true;
} catch (e) {
  // appease eslint
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
  let n = number;
  var c = isNaN((decimals = Math.abs(decimals))) ? 2 : decimals;
  let d = dec_point === undefined ? ',' : dec_point;
  let t = thousands_sep === undefined ? '.' : thousands_sep;
  var s = n < 0 ? '-' : '';
  var i = `${parseInt((n = Math.abs(+n || 0).toFixed(c)))}`;
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
}

const currencySymbolMapping = Immutable.fromJS({
  default: {
    symbol: '$',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  AUD: {
    symbol: 'A$',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  MYR: {
    symbol: 'RM ',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  USD: {
    symbol: 'US$',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  SGD: {
    symbol: 'S$',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  EUR: {
    symbol: '€',
    decimals: 2,
    dec_point: ',',
    thousands_sep: ' ',
  },
  CNY: {
    symbol: 'CN¥ ',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  CZK: {
    symbol: 'Kč ',
    decimals: 2,
    dec_point: ',',
    thousands_sep: ' ',
  },
  GBP: {
    symbol: '£',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  ILS: {
    symbol: '₪',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  INR: {
    symbol: '₹ ',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  JPY: {
    symbol: '¥',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  KRW: {
    symbol: '₩',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  THB: {
    symbol: '฿',
    decimals: 2,
    dec_point: '.',
    thousands_sep: ',',
  },
  VND: {
    symbol: '₫',
    decimals: 0,
    dec_point: '.',
    thousands_sep: ',',
  },
});

export const supportedCurrencies = currencySymbolMapping
  .keySeq()
  .filter((x) => x !== 'default')
  .sort()
  .toJS();

export const defaultCurrency = 'AUD';

export function priceFormat(
  price,
  currency = null,
  toFixed = false,
  padding = ''
) {
  if (price === 0) {
    return 'Free';
  }

  let options = currencySymbolMapping.get('default');
  options = options.set('symbol', `${currency} `);
  if (currency && currencySymbolMapping.has(currency)) {
    options = options.merge(currencySymbolMapping.get(currency));
  }
  if (toFixed === false && price % 1 === 0) {
    options = options.set('decimals', 0);
  }
  return `${options.get('symbol')}${padding}${numberFormat(
    price,
    options.get('decimals'),
    options.get('dec_point'),
    options.get('thousands_sep')
  )}`;
}

export function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function titleCase(str) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}

export function extractDomain(url) {
  let domain;
  // find & remove protocol (http, ftp, etc.) and get domain
  if (url.indexOf('://') > -1) {
    domain = url.split('/')[2];
  } else {
    domain = url.split('/')[0];
  }

  // find & remove port number
  domain = domain.split(':')[0];

  return domain;
}

const resizeRatio = window.devicePixelRatio >= 2 ? 2 : 1;

function applyResponsiveResizeDimensions(resizeTransform) {
  return resizeTransform
    .split(',')
    .reduce((ret, param) => {
      const parts = param.split(':');
      const key = parts[0];
      let value = parts[1];

      if ($.inArray(key, ['w', 'width', 'h', 'height']) !== -1) {
        value = parseInt(value, 10) * resizeRatio;
      }

      ret.push(`${key}:${value}`);
      return ret;
    }, [])
    .join(',');
}

export function transformImageURL(
  transformURL,
  transform,
  imageURL,
  responsive = true
) {
  const parser = document.createElement('a');
  parser.href = imageURL;

  const bypass = true; // TOFIX: replace rackspace transform

  if (
    parser.hostname === 'latex.scdn5.secure.raxcdn.com' ||
    parser.hostname === 'math.openlearning.com' ||
    bypass
  ) {
    return imageURL; // don't try to resize svgs from latex render service
  }

  // try to detect any other svg sources
  if (parser.pathname.endsWith('.svg')) {
    return imageURL; // don't try to resize any files with .svg file extension
  }

  // For now don't try to resize .gif file extensions because the filestack transformation sometimes makes the files much bigger
  if (parser.pathname.endsWith('.gif')) {
    return imageURL;
  }

  let queryParams = Immutable.Map(transform || {});
  if (queryParams.has('resize') && resizeRatio !== 1 && responsive) {
    queryParams = queryParams.update('resize', (resizeTransform) =>
      applyResponsiveResizeDimensions(resizeTransform)
    );
  }

  if (
    parser.hostname.endsWith('openlearning.com') ||
    parser.hostname === 'localhost'
  ) {
    parser.search = `${
      parser.search ? `${parser.search}&` : '?'
    }${queryParams.map((v, k) => `${k}=${v}`).join('&')}`;
    return parser.href;
  }

  queryParams = queryParams.merge({ url: imageURL });
  return transformURL
    ? `${transformURL}?${queryParams
        .map((value, key) => `${key}=${value}`)
        .join('&')}`
    : imageURL;
}

export function executeAfterMinDelay(callback, startTime, minDelay) {
  const delta = Date.now() - startTime;
  if (delta < minDelay) {
    setTimeout(() => {
      callback();
    }, minDelay - delta);
  } else {
    callback();
  }
}

export function getRoutePath(pathname, query) {
  const params = query.filter((x) => x);
  return `${pathname}?${params
    .map((value, key) => `${key}=${value}`)
    .join('&')}`;
}

export function truncate(text, maxChars) {
  const result = text.trim();
  if (result.length >= maxChars) {
    return `${result.substring(0, maxChars - 3)}...`;
  }
  return result;
}

export function getAdminAction() {
  const parseLocationForAdminAction = (location) => {
    let adminAction = '';
    let matches = null;
    const matchesCourseOrCohortAdmin = location.pathname.match(
      /^\/(courses|cohorts)\/admin\/$/
    );

    if (matchesCourseOrCohortAdmin && matchesCourseOrCohortAdmin.length === 2) {
      matches = location.search.match(/.*action=([^&]+)/);
      if (matches && matches.length === 2) {
        adminAction = `${matchesCourseOrCohortAdmin[1]}_${matches[1]}`;
      }
    } else if (location.pathname.startsWith('/assessment/')) {
      matches = location.pathname.match(/^\/assessment\/(\w+)-(\w+)\/.*$/);
      if (matches && matches.length === 3) {
        adminAction = `assessment_${matches[2]}`;
      }
    } else if (location.pathname.startsWith('/certification/')) {
      matches = location.pathname.match(/^\/certification\/(\w+)\/$/);
      if (matches && matches.length === 2) {
        adminAction = `certification_${matches[1]}`;
      }
    }

    return adminAction;
  };

  // const tests = [
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=starter',
  //     expected: 'courses_starter'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=outcomes',
  //     expected: 'courses_outcomes'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=general',
  //     expected: 'courses_general'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=appearance',
  //     expected: 'courses_appearance'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=content',
  //     expected: 'courses_content'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=community',
  //     expected: 'courses_community'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=roles',
  //     expected: 'courses_roles'
  //   },
  //   {
  //     url: 'http://localhost:8000/courses/admin/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017&action=advanced',
  //     expected: 'courses_advanced'
  //   },
  //   {
  //     url: 'http://localhost:8000/cohorts/admin/?course=courses/new-groups-course&action=general',
  //     expected: 'cohorts_general'
  //   },
  //   {
  //     url: 'http://localhost:8000/cohorts/admin/?course=courses/new-groups-course&action=timeline',
  //     expected: 'cohorts_timeline'
  //   },
  //   {
  //     url: 'http://localhost:8000/cohorts/admin/?course=courses/new-groups-course&action=students',
  //     expected: 'cohorts_students'
  //   },
  //   {
  //     url: 'http://localhost:8000/cohorts/admin/?course=courses/new-groups-course&action=statistics',
  //     expected: 'cohorts_statistics'
  //   },
  //   {
  //     url: 'http://localhost:8000/cohorts/admin/?course=courses/new-groups-course&action=advanced',
  //     expected: 'cohorts_advanced'
  //   },
  //   {
  //     url: 'http://localhost:8000/assessment/assessment-settings/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'assessment_settings'
  //   },
  //   {
  //     url: 'http://localhost:8000/assessment/assessment-design/designs/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'assessment_design'
  //   },
  //   {
  //     url: 'http://localhost:8000/assessment/class-assessment/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'assessment_assessment'
  //   },
  //   {
  //     url: 'http://localhost:8000/certification/settings/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'certification_settings'
  //   },
  //   {
  //     url: 'http://localhost:8000/certification/appearance/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'certification_appearance'
  //   },
  //   {
  //     url: 'http://localhost:8000/certification/students/?course=courses/new-groups-course&cohort=courses/new-groups-course/Cohorts/ClassOf2017',
  //     expected: 'certification_students'
  //   },
  //   /* courses under an institution with a custom domain */
  //   {
  //     url: 'https://www.openlearning.com/courses/admin/?course=learn/courses/bsbcmm401&cohort=learn/courses/Bsbcmm401/Cohorts/ClassOf2016&action=outcomes',
  //     expected: 'courses_outcomes'
  //   },
  //   {
  //     url: 'https://www.openlearning.com/cohorts/admin/?course=learn/courses/bsbcmm401&action=students',
  //     expected: 'cohorts_students'
  //   },
  //   {
  //     url: 'https://www.openlearning.com/assessment/assessment-settings/?course=learn/courses/bsbcmm401&cohort=learn/courses/Bsbcmm401/Cohorts/ClassOf2016',
  //     expected: 'assessment_settings'
  //   },
  //   {
  //     url: 'https://www.openlearning.com/certification/settings/?course=learn/courses/bsbcmm401&cohort=learn/courses/Bsbcmm401/Cohorts/ClassOf2016',
  //     expected: 'certification_settings'
  //   },
  //   /* reordering or get params */
  //   {
  //     url: 'https://www.openlearning.com/cohorts/admin/?action=students&course=learn/courses/bsbcmm401&cohort=blah',
  //     expected: 'cohorts_students'
  //   },
  // ];
  //
  // for (let i = 0; i < tests.length; i++) {
  //   const parser = document.createElement('a');
  //   parser.href = tests[i].url;
  //   const actual = parseLocationForAdminAction(parser);
  //   console.log(actual === tests[i].expected ? '[passed]' : '[failed]', tests[i].expected, actual);
  // }

  return parseLocationForAdminAction(window.location);
}

export const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  // fix for IE11 which sets the value of body as null if taking in a blank string
  if (doc.body) {
    return doc.body.textContent;
  } else {
    return '';
  }
};

// Input: an array of conditions with infixed operators
// Output: an array of conditions in RPN (Reverse Polish Notation)
// e.g.
// ['a', 'and', 'b', 'and', 'c' , 'and', 'd', or, 'e']
// => ['a', 'b', 'and', 'c', 'and', 'd', 'and', 'e', 'or']
export const infixToRPN = (infixedConditionsArray) => {
  let output = [];
  const operatorStack = [];

  const isOp = (el) => {
    return el === 'and' || el === 'or';
  };

  infixedConditionsArray.forEach((element) => {
    if (!isOp(element)) {
      output.push(element);
    }

    if (isOp(element)) {
      operatorStack.push(element);
      if (operatorStack.length > 1) {
        const top = operatorStack.shift();
        output.push(top);
      }
    }
  });

  if (operatorStack.length > 0) {
    output = output.concat(operatorStack);
  }

  return output;
};

export const downloadFile = (content, fileName, mimeType) => {
  window.URL = window.webkitURL || window.URL;

  const bb = new Blob([content], { type: mimeType });
  const a = document.createElement('a');
  a.download = fileName;
  a.href = window.URL.createObjectURL(bb);
  a.click();
};

export const randomPassword = (
  len = 8,
  minUpper = 0,
  minLower = 0,
  minNumber = -1,
  minSpecial = -1
) => {
  let chars = String.fromCharCode(...Array(127).keys()).slice(33); // chars
  const A2Z = String.fromCharCode(...Array(91).keys()).slice(65); // A-Z
  const a2z = String.fromCharCode(...Array(123).keys()).slice(97); // a-z
  const zero2nine = String.fromCharCode(...Array(58).keys()).slice(48); // 0-9
  const specials = chars.replace(/\w/g, '');

  if (minSpecial < 0) chars = zero2nine + A2Z + a2z;

  if (minNumber < 0) chars = chars.replace(zero2nine, '');

  const minRequired = minSpecial + minUpper + minLower + minNumber;
  const rs = [].concat(
    Array.from(
      { length: minSpecial || 0 },
      () => specials[Math.floor(Math.random() * specials.length)]
    ),
    Array.from(
      { length: minUpper || 0 },
      () => A2Z[Math.floor(Math.random() * A2Z.length)]
    ),
    Array.from(
      { length: minLower || 0 },
      () => a2z[Math.floor(Math.random() * a2z.length)]
    ),
    Array.from(
      { length: minNumber || 0 },
      () => zero2nine[Math.floor(Math.random() * zero2nine.length)]
    ),
    Array.from(
      {
        length: Math.max(len, minRequired) - (minRequired || 0),
      },
      () => chars[Math.floor(Math.random() * chars.length)]
    )
  );
  return rs.join('');
};

// from https://stackoverflow.com/a/1054862/13041484
export const convertTitleToPath = (title) => {
  return title
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
};
